import type { IconData } from '@stacksjs/iconify-core'

export const contentVideo: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 2H0v12h12v-3a5 5 0 0 0 4 2V3a5 5 0 0 0-4 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentVideo
